import { useInfiniteQuery, useQuery } from 'react-query';
import { productService } from 'services';
import { pushToGTM } from 'utils';
import { ServerStateKeysEnum } from '../constants';

export const useSearchQuery = (
  searchKeyword: string,
  sortDirection: string
) => {
  return useInfiniteQuery(
    `${ServerStateKeysEnum.searchProducts} - ${searchKeyword} - ${sortDirection}`,
    ({ pageParam = 1 }) => {
      return productService.searchProducts(
        searchKeyword,
        pageParam,
        sortDirection
      );
    },
    {
      getNextPageParam: (lastpage, pages) => {
        if (typeof lastpage.currentPageNumber === 'undefined') {
          return undefined;
        }

        if (lastpage.currentPageNumber === lastpage.totalPages) {
          return undefined;
        } else {
          return lastpage.currentPageNumber + 1;
        }
      },
      staleTime: Infinity,
      onSuccess: data => {
        pushSearchEventToGTM(searchKeyword);
      },
    }
  );
};

const pushSearchEventToGTM = (searchTerm: string) => {
  pushToGTM('search', {
    ecommerce: {
      search_term: searchTerm,
    },
  });
};
